module.exports = __webpack_public_path__ + "media/images/featured-products/cod-cb5fca2012513c0d023cfb9653c1e033.svg";